<template>
  <!--报警设置-->
  <div class="common-space-between">
       
       <NavBlock></NavBlock>                               <!--左侧导航栏按钮-->
       <Fuelgas v-if='code=="lgat"'/>                      <!--工业燃气报警器-->
       <FuelgasSG v-else-if='code=="gahft"'/>              <!--燃气4G主机报警器-->         
       <Door v-else-if ='code=="gmt"'/>                    <!--门磁-->
       <Smoke v-else-if ='code=="sdt"'/>                   <!--厌恶探测器-->
       <SmokeHouse v-else-if ='code=="dgat"'/>             <!--家用燃气报警器-->
       <SmokeFuhe v-else-if ='code=="sscdt"'></SmokeFuhe>  <!--烟感复合探测器-->
       <Monoxide v-else-if ='code=="cstct"'></Monoxide>  <!--烟感复合探测器-->
       <div class="common-space-around common-items-center expect" :style='{height:this.$store.state.windowHeight-180+"px"}' v-else>
          <div>
              <img class="expectImg" src="@/assets/custom-image/expect.svg"/> 
              <div class="text">正在接入中敬请期待</div> 
          </div>  
       </div>
  </div>
</template>
<script>
 import {setRouterNav} from '@/utils/util'
 import NavBlock from '../common-module/navBtn-block.vue'

 import Door from './block-door/index.vue'                    //安防探测器-门磁
 import Fuelgas from './block-fuelgas/index.vue'              //消防探测器-工业燃气报警器
 import FuelgasSG from './block-fuelgasSG/index.vue'          //消防探测器-燃气4G主机报警器
 import Smoke from './block-smoke/index.vue'                  //消防探测器-烟雾探测器
 import SmokeHouse from './block-smoke-house/index.vue'       //消防探测器-家用燃气报警器
 import SmokeFuhe from './block-smoke-fuhe/index.vue'         //消防探测器-烟感复合探测器
 import Monoxide from './block-smoke-monoxide/index.vue'      //消防探测器-一氧化碳烟温符合探测器
export default {
  name: 'index',
  components:{
      NavBlock:NavBlock,
      Smoke:Smoke,
      Fuelgas:Fuelgas,
      FuelgasSG:FuelgasSG,
      Door:Door,
      SmokeHouse:SmokeHouse,
      SmokeFuhe:SmokeFuhe,
      Monoxide:Monoxide
  },
  data:()=>({  
      code:'',
  }),
  methods:{
    
    //搜索
    searchBtn(ev){
       console.log("烟感",ev)
       setRouterNav()
       this.code = ev.code
       localStorage.setItem("EQTYPEVALE",JSON.stringify(ev))
       
    }
  }
}
</script>
<style lang="scss" scoped>
    .expect{
       border: 1px solid rgba(173,173,173,0.2);
       flex: 1;
       margin-top: 30px;
       border-radius: 6px;
       padding: 10px;
       box-sizing: border-box;
       margin-right:15px;
       .expectImg{
          width: 60px;
          display: block;
          margin: 0 auto;
       }
       .text{
          font-size: 14px;
          color:rgba(173,173,173,0.6);
          text-align: center;
          padding-top: 10px;
       }
    }
</style>
